<template>
	<b-row>
		<base-dialog v-model="dialogOpenlegalLaywerVisible" :okFn="() => { registerUser(this.USER_TYPES.PROFESSIONAL) }" :cancelFn="() => { dialogOpenlegalLaywerVisible = false }" :content="$t('login.dialog-lawyer')"></base-dialog>
		<b-col cols="12" xl="6" class="card-ctn">
			<div class="card-login" :style="{ 'min-height': cardHeight }">
				<div class="my-auto">
					<!-- <h3>{{ $t('login.already-signed-in') }}</h3> -->
					<login-form :title="$t('login.already-signed-in')" :token="loginToken"/>
				</div>
			</div>
		</b-col>
		<b-col cols="12" xl="6" class="card-ctn">
			<div class="card-login" :style="{ 'min-height': cardHeight }">
				<div class="my-auto">
					<div>
						<h3>
							{{ $t('login.new-user') }}
						</h3>
						<p style="white-space:initial" v-if="!inOpensalud360()">
							{{ $t('login.register-now') }}
						</p>
					</div>
					<base-button variant="primary" class="mt-4 d-block w-100 btn-mobile" v-if="showProfessionalButton" @click="registerProfessional">
						{{ inOpenlegal() ? $t('login.iam-lawyer') : $t('login.iam-professional') }}
					</base-button>
					<base-button variant="primary" class="w-100 btn-mobile mt-4 d-block" @click="registerPatient">
						{{ patientBtnText }}
					</base-button>
					<base-button v-if="showCenterButton" variant="primary" class="w-100 btn-mobile mt-4 d-block" @click="registerCenter">
						{{ inOpenlegal() ? $t('login.iam-lawfirm') : $t('login.iam-centre') }}
					</base-button>
				</div>
			</div>
		</b-col>
	</b-row>

</template>

<script>
import { BForm, BAlert, BFormGroup, BFormInput, BFormInvalidFeedback, BButton } from 'bootstrap-vue'
import LoginForm from '@/components/forms/LoginForm'
import router from '@/router/index'
import { inOpensalud360, inOpenlegal } from '@/constants/platformNames'
import accountMixin from '@/mixins/account.mixin'
import BaseDialog from '@/components/base/BaseDialog'
import CompaniesRepository from '@/repositories/CompaniesRepository'

export default {
  name: 'Login',
  mixins: [accountMixin],
  components: {
    BForm,
    BAlert,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    LoginForm,
		BaseDialog
  },
  data () {
    return {
      USER_TYPES: null,
			dialogOpenlegalLaywerVisible: false,
			inOpenlegal,
			inOpensalud360
    }
  },
  methods: {
		registerUser (userType) {
			const currentQuery = { ...router.currentRoute.query }
			let returnUrl = currentQuery.returnUrl || currentQuery.ReturnUrl

			// Regex to capture string like HomePaciente, HomeProfesional, HomeCentro in return url
			if (returnUrl) {
				const match = /home(paciente|profesional|centro)+/i.exec(returnUrl)
				if (match && match[1] && match[1].toLowerCase() !== userType) {
					returnUrl = null
				}
			}

			// Encode the returnUrl and add it back to the query parameters
			if (returnUrl) {
				currentQuery.returnUrl = encodeURIComponent(returnUrl)
			}

			// Construct the URL with all query parameters
			this.$router.push({
				path: `/registro-${userType}`,
				query: currentQuery
			})
		},
		registerProfessional () {
			if (this.inOpenlegal()) {
				this.dialogOpenlegalLaywerVisible = true
				return
			}
			return this.registerUser(this.USER_TYPES.PROFESSIONAL)
		},
		registerPatient () {
			return this.registerUser(this.USER_TYPES.PATIENT)
		},
		registerCenter () {
			return this.registerUser(this.USER_TYPES.CENTER)
		}
  },
  async created () {
    /* this.redirectIfAuthenticated() */
    this.USER_TYPES = {
      PATIENT: this.inOpenlegal() ? 'cliente' : 'paciente',
      PROFESSIONAL: this.inOpenlegal() ? 'abogado' : 'profesional',
      CENTER: this.inOpenlegal() ? 'bufete' : 'centro'
    }

		// If query param code is present, request the company code info and redirect if OAuthAuthorizeUrl is present
		if (this.$route.query.code) {
			await CompaniesRepository.getCode(this.$route.query.code).then((response) => {
				const { oAuthAuthorizeUrl } = response.data
				if (oAuthAuthorizeUrl) {
					window.location.href = oAuthAuthorizeUrl
				}
			})
		}
  },
  computed: {
    showProfessionalButton () {
      return !inOpensalud360()
    },
    showCenterButton () {
      return !this.inOpenlegal() && !inOpensalud360()
    },
    patientBtnText () {
      return this.inOpenlegal() ? this.$t('login.iam-client') : (inOpensalud360() ? this.$t('signup-title') : this.$t('login.iam-patient'))
    },
		cardHeight () {
			return !this.$uiHelpers.isMobile ? (this.inOpenlegal() ? '540px' : '457px') : 'auto'
		},
		loginToken () {
			if (this.$route.query.token) return this.$route.query.token
			if (this.$store.getters['session/isLoggedInHost']) return this.$apiToken
			return null
		}
  }
}
</script>

<style lang="scss" scoped>
  // @import '~css/public/login';

	.card-ctn {
		@include media(desktop-xl) {
			padding: 2rem 6rem !important;
		}

		@include desktop {
			padding: 2rem;
		}
		
		@include media(tablets, mobile) {
			padding: 1rem 0rem;
		}
	}

  @include mobile {
    .neu-cards-slider {
      padding: 0 !important;

      .row [class*="col-"] {
        margin-left: 0 !important;
      }
    }
  }

 /deep/ .form-group{
  margin-bottom: 1.5rem !important;
  margin-top: 1rem !important;
  }
  .neu-cards-slider {
    font-size:14px !important;
    @include mobile {
      padding: 1rem;
    }
    &:not(.black) {
      background-repeat: no-repeat;
      background-size: cover;
      background-position-y: center;
    }
    
    justify-content: center;
    .btn{
      @include desktop {
        margin-top: 3%

      }
      @include media(tablets, mobile) {
        margin-bottom: 10%

      }
    }
    @include tablets {
      .row {
        display: contents;
        overflow-x: hidden;
        overflow-y: hidden;
        white-space: nowrap;

        [class*="col-"] {
          display: inline-block;
          width: 100%;
          // margin-right: 50%;
        }
      }
    }
    @include mobile {
      .row {
        display: contents;
        overflow-x: hidden;
        overflow-y: hidden;
        white-space: nowrap;

        [class*="col-"] {
          display: inline-block;
          width: 100%;
          @media screen and (max-width: 320px) {
          margin-right: 50%;
        }
        @media screen and (min-width: 321px) and (max-width: 425px) {
          margin-left: 2%;
        }
        }
      }
    }

    @include media(tablets,mobile) {
      .row {
        margin-bottom: 2rem;
        margin-block-end: 5rem;

        &::-webkit-scrollbar {
          height: 3px;
        }
        
        &::-webkit-scrollbar-track {
          background-color: $gray-600;
          border-radius: 100px;
        }
        
        &::-webkit-scrollbar-thumb {
          background-color: $black;
          border-radius: 100px;
        }

        span {
          white-space: normal;
        }
      }
    }
 .card-ctn2-login {
      display: flex;
  
      @include desktop {
        padding:  5rem 3rem 11rem;
      }
      @include desktop-sm {
        padding:  5rem 3rem 11rem;
      }
      @include tablets {
        padding:  5rem ;
      }
      @include mobile {
        padding-bottom: 2rem;
      }
      .btn-mobile{
        @include mobile {
          margin-bottom: 1rem !important;
      }
      }
     
      .neu-card-price {
        width:20rem;
            transition-duration: 9999999s;
            justify-content:center ;
        &:hover {
            @include desktop {
                padding: 5rem;
            }
            @include desktop-sm {
              padding: 2rem 5rem;
            }
      
      transition-duration: 999999999s;
      }
        @include desktop {
          display: flex;
          padding: 5rem;
          height: 470px;
          width: 320px;
        }
        @include desktop-sm {
          display: flex;
          padding: 3rem 5rem;
          height: 400px;
          width: 320px;
        }

        @include tablets {
          display: table-cell;
          padding: 7rem;
          width: 100%;
          max-width: none;

          span{
            margin: auto;
          }
        }

        @include mobile {
          display: block;
          padding: 5rem 3rem;
          margin-bottom: 3rem;
          min-height: 280px;
        }
      }
      
    }
    .card-ctn {
      display: flex;

      @include desktop {
        padding: 0 7rem;
      }
      @include desktop-sm {
        padding: 0 2rem;
      }
      @include tablets {
        padding: 0;
      }
      @include media(tablets, mobile) {
        margin-right: 5rem;
        padding-right: 4rem;
        padding-left: 4rem;
        padding-top: 4rem;
        padding-bottom: 2rem;
      }
 .neu-card-price {
        display: flex;
        @include desktop {
          padding: 5rem;
          min-height: 400px;
          max-width: 350px;
        }
        @include desktop-sm {
          padding: 2rem 5rem;
          min-height: 300px;
          max-width: 250px;
        }

        @include tablets {
          padding: 7rem;
          width: 100%;
          max-width: 250px;

          span {
            margin: auto;
          }
        }

        @include mobile {
          padding: 5rem 3rem;
          margin-bottom: 3rem;
          min-height: 280px;
        }
      }
      .neu-card {
        display: flex;
        @include desktop {
          padding: 5rem;
          min-height: 400px;
          max-width: 350px;
        }
        @include desktop-sm {
          padding: 2rem 5rem;
          min-height: 300px;
          max-width: 250px;
        }

        @include tablets {
          padding: 7rem;
          width: 100%;
          max-width: 250px;

          span {
            margin: auto;
          }
        }

        @include mobile {
          padding: 5rem 3rem;
          margin-bottom: 3rem;
          min-height: 280px;
        }
      }
      .neu-card-rates {
        display: flex;
        @include desktop {
          padding: 5rem;
          min-height: 500px;
          max-width: 220px;
        }
        @include desktop-sm {
          padding: 2rem 5rem;
          min-height: 300px;
          max-width: 250px;
        }

        @include tablets {
          padding: 7rem;
          width: 100%;
          max-width: none;

          span {
            margin: auto;
          }
        }

        @include mobile {
          padding: 5rem 3rem;
          margin-bottom: 3rem;
          min-height: 280px;
        }
      }
    }
  }
  .card-login {
  width: 100%;
  display: flex;
  h3{
    color: black
  }
  flex-direction: column;
  background-color: #eee;
  border-radius: $border-radius !important;
  box-shadow: $custom-shadow;
  @include desktop {
    padding: 4rem 6rem;
  }
  @include desktop-sm {
    padding: 1rem 3rem;
  }
  @include tablets {
    padding: 3rem 6rem;
  }
  @include mobile {
    padding: 2.5rem 1.5rem;
    h3{
      font-size: 1.3rem;
    }
  }
  border: 0px !important;
  box-sizing: border-box;
  border-radius: 10px;
  // display: block;
  // flex-direction: column;
  text-align: center;
  .card-ctn2 {
      display: flex;
    
    }
}
</style>


// WEBPACK FOOTER //
// src/components/views/account/LoginOrRegister.vue